function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class ControllerError extends Error {
    constructor(message, cause){
        const _message = cause && typeof cause === 'object' && 'message' in cause ? `${message}, ${cause.message}` : message;
        super(_message, {
            cause
        }), _define_property(this, "cause", void 0), this.cause = cause;
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = this.constructor.name;
    }
}

//# sourceMappingURL=errors.js.map